import { render, staticRenderFns } from "./FiltersBrand.vue?vue&type=template&id=92e8c0ae&"
import script from "./FiltersBrand.vue?vue&type=script&lang=js&"
export * from "./FiltersBrand.vue?vue&type=script&lang=js&"
import style0 from "./FiltersBrand.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports